// libraries
import moment from 'moment';

export function formatDate(date: Date | null): string {
	if (date === null) return '-';

	const format: string = 'ddd DD/MM-YY HH:mm';
	const dateString: string = moment(date).format(format);
	return dateString;
}
